import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { App } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class AppService extends UzurvRestService {
  readonly resourceUrl = 'apps/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of apps
   *
   * @param pageNumber
   * @param pageSize
   */
  listAll(pageNumber: number, pageSize: number): Observable<Array<App>> {
    return this.get<Array<App>>(this.resourceUrl, {
      pageNumber: pageNumber,
      pageSize: pageSize
    }).pipe(map(response => Deserialize(response, App)));
  }
}
